import {Docks} from './Docks';

export class Almacen {
  public codAlmacen: string = '';
  public descAlmacen: string = '';
  public dock: Docks | null = new Docks();
  public usrCreacion: string;
  public fecCreacion: Date;
  public usrModif: string | null;
  public fecModif: Date | null;

  public static combinedAlmacen(almacen: Almacen): string {
    if (!almacen.codAlmacen) {
      return '';
    } else {
      return almacen.codAlmacen + ' - ' + almacen.descAlmacen;
    }
  }
}
